import { createFileRoute } from '@tanstack/react-router'

import { CurriculumsManagementAdd } from '@/modules/curriculumsManagement'

export const Route = createFileRoute('/_auth/curricula/add')({
  component: CurriculumsManagementAdd
})
